export default {
    locale: "ru",
};

export const api_key = "i21gzlea68d6xcpwz0j029zsptudvjiwtt1t3cxxswko28pr";
